import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'expensify-details',
    templateUrl: './expensify-details.component.html',
    styleUrls: ['./expensify-details.component.scss'],
    standalone: false
})
export class ExpensifyDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
